export const CATALOG_IMAGE_WIDTH = 186;
export const CATALOG_IMAGE_HEIGHT = 186;

export const BASE_IMAGE_WIDTH = 172;
export const BASE_IMAGE_HEIGHT = 172;

export const MOBILE_PRODUCT_IMAGE_WIDTH = 250;

export const PRODUCT_IMAGE_WIDTH = 309;
export const PRODUCT_IMAGE_HEIGHT = 309;

export const EXCLUDE_CATEGORIES = [
    'a26', // adult
    'b243' // alcohol
];
